import React, { Component } from 'react'
import { connect } from 'react-redux'
import { uniq } from 'lodash'
import TradeMark from '../tradeMark/TradeMark'
import royalLogoWhite from '../../assets/images/rccl-logo-light.png'
import { getAllActivePackagesDetails } from '../../reducers/setActivePackageReducers'
import GeneralTermsAndConditions from '../terms/GeneralTermsAndConditions'

class EQuoteReviewEmailFooter extends Component {
  constructor(props) {
    super(props)
    this.state = {}
  }
  render() {
    const { templateClass, brandsSelected, activePackageData } = this.props

    return (
      <div className={'equote__review-construct-email-footer ' + templateClass}>
        <GeneralTermsAndConditions />
        <div className="equote__review-construct-email-copyright">
          <TradeMark activePackages={activePackageData} />
        </div>
        <div className="equote__review-construct-email-footer-logo">
          {uniq(brandsSelected).map(brand => {
            let iconSrc
            if (brand.brand_code === 'R') {
              iconSrc = royalLogoWhite
            } else {
              iconSrc =
                brand && brand.badge_light ? brand.badge_light.file : null
            }
            const title =
              brand && brand.badge_light
                ? brand.badge_light.marketing_title
                : null
            return <img src={iconSrc} alt={title} key={title} />
          })}
        </div>
      </div>
    )
  }
}

const mapStateToProps = state => {
  return {
    activePackageData: getAllActivePackagesDetails(state)
  }
}

export default connect(mapStateToProps)(EQuoteReviewEmailFooter)
